import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { handleRegisterLinkClick } from "@/utils/trackRegisterClick";

type BannerCompany = {
  id: string;
  name: string;
  logo: string;
  url: string;
  promoText: string;
};

const bannerCompanies: BannerCompany[] = [
  { id: "mrboom9", name: "MRBOOM9", logo: "/casinoLogoOri/mrboom9.png", url: "https://mrboom9.com/RFPPOKINOMICS", promoText: "Register Free $99.99 + Apps Daily $20" },
  { id: "ipay9", name: "IPAY9", logo: "/casinoLogoOri/ipay9.png", url: "https://i9aud.net/RFPOKINOMICS1", promoText: "Monthly Deposit Ranking $1999" },
  { id: "kingbet9", name: "KINGBET9", logo: "/casinoLogoOri/kingbet9.png", url: "https://kingbett9.com/RFPOKINOMICS13", promoText: "Slot Daily Bns 39% + Missions Get $100" },
  { id: "bigpay77", name: "BIGPAY77", logo: "/casinoLogoOri/bp77.png", url: "https://bigpay77.co/RFBPOKINOMICS", promoText: "80% Welcome Bonus + 7% Weekly Rebate" },
  { id: "me99", name: "ME99", logo: "/casinoLogoOri/me99.png", url: "https://me99aus.net/RFPOKINOMICSME", promoText: "JILI Welcome Bns 80% + $1999 Deposit Ranking" },
  { id: "rolex9", name: "ROLEX9", logo: "/casinoLogoOri/rolex9.png", url: "https://rolex9au.com/RFPOKINOMICSS", promoText: "Free A$99.99 Credit + Extra A$10 Bonus" },
  { id: "gucci9", name: "GUCCI9", logo: "/casinoLogoOri/gucci9.png", url: "https://gucci9au.org/RFPOKINOMICSG", promoText: "Free A$109.99 Registration Bonus + VIP Reward Boost" },
  { id: "mrbean9", name: "MRBEAN9", logo: "/casinoLogoOri/mrbean9.png", url: "https://mrbean9au.com/RFPOKINOMICSM", promoText: "A$209.99 Bonus + 50% Welcome Boost" },
  { id: "spinaroo", name: "Spinaroo", logo: "/casinoLogoOri/spinaroo.png", url: "https://spinarooaus.com/RFPOKINOMICSP", promoText: "Daily Slot Bns 80% + Daily Bns $100" },
  { id: "winnie777", name: "WINNIE777", logo: "/casinoLogoOri/winnie777.png", url: "https://winnie777.net/RFPOKINOMICSWI", promoText: "A$99 Share Bonus + Free A$103.33 Register Reward" },
  { id: "queen13", name: "QUEEN13", logo: "/casinoLogoOri/queen13.png", url: "https://queen13au.com/RFPOKINOMICSQU", promoText: "Up to A$1825 Daily Free Bonus" },
  { id: "micky9", name: "MICKY9", logo: "/casinoLogoOri/micky9.png", url: "https://micky9.net/RFPOKINOMICSMI", promoText: "Free Credit $103.33 + Free Share Bns" },
  { id: "bybid9", name: "BYBID9", logo: "/casinoLogoOri/bybid9.png", url: "https://bybid9.net/RFPOKINOMICS", promoText: "Upto $130 Share Bns + Daily Missions $100" },
];

export default function GlobalBottomBanner() {
  const [visible, setVisible] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState<BannerCompany>(bannerCompanies[0]);
  const location = useLocation();

  // Reveal banner after scrolling 20%
  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * bannerCompanies.length);
    setSelectedCompany(bannerCompanies[randomIndex]);
    setVisible(false);

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;

      if (docHeight > 0 && scrollTop / docHeight >= 0.2) {
        setVisible(true);
        window.removeEventListener("scroll", handleScroll);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location.pathname]);

  // Broadcast banner visibility state
  useEffect(() => {
    window.dispatchEvent(new CustomEvent("bannerVisible", { detail: visible }));
  }, [visible]);

  // Close button should also broadcast false
  const closeBanner = () => {
    setVisible(false);
    window.dispatchEvent(new CustomEvent("bannerVisible", { detail: false }));
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-0 right-0 z-50 flex justify-center px-4 pointer-events-none">
      <div className="relative w-full max-w-7xl bg-[#0f172a] text-white shadow-2xl rounded-xl pointer-events-auto">

        {/* Close Button */}
        <button
          onClick={closeBanner}
          className="
            absolute -top-3 -right-3
            w-8 h-8 bg-white text-black rounded-full
            flex items-center justify-center shadow-lg
            hover:bg-gray-100 transition
          "
          aria-label="Close banner"
        >
          ✕
        </button>

        {/* Content */}
        <div className="flex items-center px-3 md:px-6 py-2.5 md:py-4 gap-3 md:gap-6">

          {/* Rank only on desktop */}
          <div className="hidden md:flex w-12 flex-shrink-0 justify-center">
            <img src="/first-rank.png" alt="Rank 1" className="w-10 h-10" />
          </div>

          {/* Logo */}
          <div className="w-20 md:w-28 flex-shrink-0 flex justify-center">
            <img
              src={selectedCompany.logo}
              alt={selectedCompany.name}
              className="h-7 md:h-10 object-contain"
            />
          </div>

          {/* Promo Text (Desktop) */}
          <div className="hidden md:block flex-1 text-center text-sm md:text-base font-medium">
            <span className="text-white/80">{selectedCompany.promoText}</span>
          </div>

          {/* Promo Text (Mobile Compact) */}
          <div className="md:hidden flex-1 min-w-0">
            <p className="text-[10px] sm:text-[11px] font-medium text-white/85 leading-snug break-words">
              {selectedCompany.promoText}
            </p>
          </div>

          {/* CTA Button */}
          <div className="flex-shrink-0">
            <a
              href={selectedCompany.url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(event) => handleRegisterLinkClick(event, {
                section: 'global_bottom_banner',
                brandName: selectedCompany.name,
                url: selectedCompany.url,
              })}
              className="
                bg-yellow-400 text-black font-semibold
                px-3 md:px-5 py-1.5 md:py-2 rounded-md
                hover:bg-yellow-300 transition
                text-xs md:text-base
                whitespace-nowrap
              "
            >
              <span className="md:hidden">Register</span>
              <span className="hidden md:inline">Register Now</span>
            </a>
          </div>

        </div>
      </div>
    </div>
  );
}
